module.exports = __webpack_public_path__ + "static/buttons-4de9553ed74c4f1c59115379f3f0cab3.png";